import React from 'react';
import { strategyRules } from '../data/strategy';
export function StrategyBreakdown() {
  return <section id="estrategia" className="border-b border-line" data-id="element-131" data-mp="yikspj17oex7">
      <div className="mx-auto w-full max-w-[1400px] px-5 py-16 sm:px-6 lg:px-10 lg:py-24" data-id="element-132" data-mp="ylgp32xeuvjj">
        <div className="max-w-2xl" data-id="element-133" data-mp="tqb2e1w6pcue">
          <h2 className="text-[22px] font-semibold tracking-tight text-white sm:text-3xl" data-id="element-134" data-mp="otui5is3viml">
            El Protocolo, en tres reglas.
          </h2>
          <p className="mt-3 text-[14px] leading-relaxed text-white/50 sm:text-[15px]" data-id="element-135" data-mp="kt0tuoar41t6">
            Un sistema cerrado: sin criterio discrecional, sin excepciones. Cada
            regla define exactamente qué se observa y cuándo se ejecuta.
          </p>
        </div>

        <div className="mt-10 grid gap-px border-t border-line bg-line md:mt-14 md:grid-cols-3" data-id="element-136" data-mp="5vi4pku5vml7">
          {strategyRules.map(rule => <article key={rule.id} className="flex flex-col bg-ink px-0 pb-6 pt-6 md:px-8 md:pb-2 md:pt-8" data-id="element-137" data-mp="255ghk5di53uw">
              <div className="flex items-baseline justify-between" data-id="element-138" data-mp="w0fw7o94jph">
                <span className="font-mono text-[12px] tracking-[0.2em] text-cyan-vip" data-id="element-139" data-mp="5vd1kp3dzkqh">
                  {rule.id}
                </span>
                <span className="font-mono text-[11px] tracking-[0.18em] text-white/30" data-id="element-140" data-mp="3n4jjku9ul658">
                  {rule.meta}
                </span>
              </div>
              <h3 className="mt-4 text-lg font-medium tracking-tight text-white sm:text-xl md:mt-6" data-id="element-141" data-mp="jn1fmxx74ja3">
                {rule.title}
              </h3>
              <p className="mt-2.5 text-[14px] leading-relaxed text-white/50" data-id="element-142" data-mp="olbblaqqvnwr">
                {rule.description}
              </p>
              <div className="mt-auto pt-6 md:pt-8" data-id="element-143" data-mp="9v41pjeszd7o">
                <span className="block h-px w-10 bg-gold-vip/60" data-id="element-144" data-mp="euzyaxl682d7" />
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}